import { useAuth } from "../auth/AuthContext";

const _apiBaseRaw =
  process.env.REACT_APP_API_BASE_URL !== undefined
    ? String(process.env.REACT_APP_API_BASE_URL).trim()
    : "";
const API_BASE_URL = _apiBaseRaw === "" ? "/api" : _apiBaseRaw;

export const apiFetch = (url: string, options: RequestInit = {}) => {
  const { headers, ...rest } = options;
  return fetch(`${API_BASE_URL}${url}`, {
    ...rest,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(headers && typeof headers === "object" && !Array.isArray(headers) ? headers : {}),
    },
  });
};

// Backward compat per chi importa API_BASE o http / useHttp
export const API_BASE = API_BASE_URL;

export async function http<T>(
  path: string,
  opts: RequestInit = {},
  token?: string | null
): Promise<T> {
  const res = await apiFetch(path, {
    ...opts,
    headers: {
      ...(opts.headers ?? {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    if (res.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("nat:unauthorized", {
          detail: { path, status: res.status },
        }),
      );
    }
    throw new Error(`HTTP ${res.status}: ${txt}`);
  }
  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    const preview = (await res.clone().text().catch(() => "")).slice(0, 120);
    throw new Error(
      `Risposta non JSON da ${path} (content-type: ${contentType || "assente"}). ` +
        `Su narcil verificare nginx: location /api/ deve fare proxy_pass a :3002 senza rimuovere /api. ` +
        `Anteprima: ${preview}`,
    );
  }
  return res.json() as Promise<T>;
}

export function useHttp() {
  const { token } = useAuth();
  return {
    get: <T,>(path: string) => http<T>(path, { method: "GET" }, token),
    post: <T,>(path: string, body: unknown) =>
      http<T>(path, { method: "POST", body: JSON.stringify(body) }, token),
  };
}
